import { render, staticRenderFns } from "./CourseCreateStaffInfo.vue?vue&type=template&id=18f61f08&"
import script from "./CourseCreateStaffInfo.vue?vue&type=script&lang=ts&"
export * from "./CourseCreateStaffInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports